/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PageInfo } from "./PageInfo";
import { StationMaintenanceResource } from "./StationMaintenanceResource";
import * as t from "io-ts";

// required attributes
const StationMaintenanceListResourceR = t.interface({
  page_info: PageInfo,

  station_maintenance_list: t.readonlyArray(
    StationMaintenanceResource,
    "array of StationMaintenanceResource"
  )
});

// optional attributes
const StationMaintenanceListResourceO = t.partial({});

export const StationMaintenanceListResource = t.intersection(
  [StationMaintenanceListResourceR, StationMaintenanceListResourceO],
  "StationMaintenanceListResource"
);

export type StationMaintenanceListResource = t.TypeOf<
  typeof StationMaintenanceListResource
>;
